import { IndexedDb, IndexedDbKey } from "@/services/indexedDb";
import { isRelativeUrl } from "@/utilities/url";

const MaxAgeMs = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

type Data = {
  url: string;
  timestamp: number;
};

export const saveAfterAuthRedirect = async (url: string): Promise<void> => {
  if (!isRelativeUrl(url)) {
    throw new Error("DEV: Only relative URLs are allowed.");
  }

  const timestamp = Date.now();
  const data: Data = { url, timestamp };
  return IndexedDb.set(IndexedDbKey.PendingAfterAuthRedirect, data); // Overwrites existing previous value
};

export const getAfterAuthRedirect = async (): Promise<string | undefined> => {
  const data = await IndexedDb.get(IndexedDbKey.PendingAfterAuthRedirect);
  if (data === undefined) {
    return undefined;
  }

  if (!("url" in data) || !("timestamp" in data)) {
    console.warn("Invalid data in IndexedDb for afterAuthRedirect.", data);
    clearAfterAuthRedirect();
    return undefined;
  }

  const timestamp = Number(data.timestamp);
  if (isNaN(timestamp)) {
    console.warn("Invalid data in IndexedDb for afterAuthRedirect.", data);
    clearAfterAuthRedirect();
    return undefined;
  }

  const age = Date.now() - timestamp;
  if (age > MaxAgeMs) {
    // No console.warn here - it's a valid scenario
    clearAfterAuthRedirect();
    return undefined;
  }

  const url = data.url;
  if (!isRelativeUrl(url)) {
    console.warn("Invalid data in IndexedDb for afterAuthRedirect.", data);
    clearAfterAuthRedirect();
    return undefined;
  }

  return url;
};

export const clearAfterAuthRedirect = async (): Promise<void> => IndexedDb.delete(IndexedDbKey.PendingAfterAuthRedirect);
